import Vue from 'vue';

const state = {
    modals: {
        alert: {
            visible : false,
            message : '',
            reload  : false,
        },
        buyPacket: {
            visible : false,
            packet  : 0,
            select  : false,
            current : false,
            upgrade : false
        },
        confirmation: {
            actionError     : false,
            actionSuccess   : false,
            confirmationType: false,
            settings        : false,
            visible         : false,
        },
        image: {
            visible: false
        },
        payout: {
            visible : false,
            params  : {}
        },
        withdrawCoins: {
            visible : false,
            coins   : 0,
            type    : 'mining', // mining | royal
            accept  : false
        }
    }
};

const getters = {
    modals: state => {
        return state.modals
    }
};

const mutations = {
    modals (state, params) {
        Vue.set(state.modals, params.modal, params.data)
    }
};

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/modals.js